

import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Autocomplete, Button } from "@mui/material"; // ✅ Correct

//import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode, FilterService } from "primereact/api";
import CreateAsset from "./../CreateAsset";
import { assetFamilyMaster, assetType, CountryMaster, UserMaster } from "../../types/assetTypes";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import {
  deleteAssetDetails,
  deleteFaultDetails,
  getFaultByIdData,
  getListOfAssets,
  getListOfFault,
  getUniqueAssetNamesByFamilyId,
} from "../../api/Services/assetServices";
import Swal from "sweetalert2";
import { OverlayPanel } from "primereact/overlaypanel";
import { Box, Card, CardActionArea, CardActions, CardContent, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import {

  getFaultColumns,
  faultBodyTableIcon,
} from "../../const/AssertData";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { getCategoryAssetMasterDataList, getCountryAssetMasterDataList, getFamilyAssetMasterDataList, getProjectByRegionId, getProjectMasterDataList, getUsersMasterDataList } from "../../api/Services/masterServie";
import * as XLSX from "xlsx";
import "xlsx-color";
import { faultTypes } from "../../types/faultTypes";
import { RootState } from "../../store/Reduxstore";
import CreateFault from "./CreateFault";
import EditFault from "./EditFault";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";

interface CreateFaultProps {
  setPathname: React.Dispatch<React.SetStateAction<string>>;
}

const SearchFault: React.FC<CreateFaultProps> = ({ setPathname }) => {
  const userDetails = useSelector((state: RootState) => state.auth)
    console.log(userDetails)
  const [searchText, setSearchText] = useState("");  
  const [selectedCard, setSelectedCard] = React.useState(0);
  const dt = useRef<DataTable<any[]>>(null);
  const [selectedValue, setSelectedValue] = useState<number | null>(null); 
  const [formData, setFormData] = useState<faultTypes>({
  
    faultId: 0,
    user_id: userDetails.userId,
    name: "",
    assetType: "",
    regionId: 0,
    projectId: 0,
    familyAssetId: 0,
    familyName: "",
    assetName: "",
    currentLocationId: 0,
    fixed_user_ids: [],
    countryName: "",
    hourMeter: 0,
    fault: "",
    worksite: "",
    date: "",
    attachments: [],
    fixedAttachments: [],
    fixed_user_id: 0,
    partsUsed: "",
    workCarriedOut: "",
    faultStatus: "",
    fixedUserName: "",
    categoryId: 0,
    categoryName: "",
    hoursSpent: 0,   
    projectName: "",
    regionName: "",
    fixedDate: "",
    
  });

  const handleDeleteFault = async (faultId: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));
        try {
          const response = await deleteFaultDetails(faultId);
          if (response.status === 200) {
            fetchFaults(paginationData.page, paginationData.rows, filters);
            CustomMessage("Fault deleted", "success", enqueueSnackbar);
          } else {
            CustomMessage(
              "Failed to delete the fault.",
              "error",
              enqueueSnackbar
            );
          }
        } catch (error: any) {
          CustomMessage(
            error?.message || "Something went wrong!",
            "error",
            enqueueSnackbar
          );
        } finally {
          dispatch(setLoading(false));
        }
      } else {
        CustomMessage("Deletion cancelled", "info", enqueueSnackbar);
      }
    });
  };
  const renderNameWithStatus = (rowData: faultTypes) => {
    const status = rowData.faultStatus?.trim().toLowerCase();

    let color = "gray";
    if (!status || status === "") {
      color = "red";
    } else if (status === "repair completed") {
      color = "green";
    } else if (
      status === "under process / waiting for parts" ||
      status === "under repairs" ||
      status === "waiting for parts"
    ) {
      color = "#FFC107"; // Yellow
    }

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div style={{ maxWidth: "calc(100% - 20px)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {rowData.name}
        </div>
        <span
          style={{
            width: "12px",
            height: "12px",
            minWidth: "12px",
            borderRadius: "50%",
            backgroundColor: color,
            display: "inline-block",
            marginLeft: "8px",
          }}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData: faultTypes) => {
      const renderIconData = faultBodyTableIcon(
        handleEditFault, 
        handleDeleteFault,       
        rowData
      );
      return (
        <>
          {renderIconData &&
            renderIconData.map((val, index) => (
              <ReusablePrimeButton key={index} {...val} />
            ))}
        </>
      );
  };
  
  const [faultId, setFaultId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const columns = getFaultColumns(actionBodyTemplate, renderNameWithStatus);
   const [faultData, setFaultData] = useState<faultTypes>
    ({
      faultId: 0,
      user_id: 0,
      name: "",
      familyAssetId: 0,
      familyName: "",
      assetName: "",
      currentLocationId: 0,
      countryName: "",
      hourMeter: 0,
      fault: "",
      worksite: "",
      date: "",
      attachments: [],
      fixedAttachments: [],
      fixed_user_id: 0,
      partsUsed: "",
      regionId: 0,
      projectId: 0,
      projectName: "",
      workCarriedOut: "",
      faultStatus: "",
      fixedUserName: "",
      fixed_user_ids: [],
      categoryId: 0,
      categoryName: "",
      hoursSpent: 0,   
      regionName: "",
      fixedDate: "",
    }); 
  

  const handleEditFault = async (faultId: number) => {
    try {
      const response = await getFaultByIdData(faultId);

      if (response.status.code === 200) { // ✅ Correctly checking HTTP 200 status
        setFaultId(faultId);
        setFaultData(response.data);  // Store fault data
        setOpen(true);
        console.log("Fetched Fault Data:", response.data);
      } else {
        console.error("Failed to fetch fault data. Status:", response.status);
      }
    } catch (error) {
      console.error("Error fetching fault data:", error);
    }
  };

  const [filters, setFilters] = useState<{
    currentLocationId:number,
    worksite:string;
    user_id:number;
    familyAssetId:number;
    assetName:string;
    projectId: number;
    categoryId: number;
    faultStatus: string;
    }>({
    currentLocationId: 0,
    projectId: 0,
    worksite: "",
    user_id: 0,
    familyAssetId: 0,
    assetName: "",
    categoryId: 0,
    faultStatus: "",
  });

  const [faults, setFaults] = useState<faultTypes[]>([]);
  const dispatch = useDispatch();
  const [countryName, setCurrentLocation] = useState<
      { label: string; value: number }[]
    >([]);  
  useEffect(() => {
      if (countryName.length === 0) getCurrentLocationList(1,PAGESEND);
    }, [countryName]); 
  
  
  const getCurrentLocationList = async (page: number, rows: number) => {
      dispatch(setLoading(true));
      try {
        const { data, status } = await getCountryAssetMasterDataList(page, rows,{currentLocationId:{value:"",matchMode: "startsWith"}});
        if (status.code === 200 && data?.length > 0) {
          const updatedData = data.map((val) => ({
            value: val.currentLocationId,
            label: val.countryName,
          }));
          updatedData.unshift({ label: "Select Country", value: 0 });
          setCurrentLocation(updatedData);
        } 
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } finally {
        dispatch(setLoading(false));
      }
    };
  
      const [familyAssetName, setFamilyAssetName] = useState<{ value: number; label: string }[]>([]);
      const [assetType, setAssetTypeList] = useState<{ value: number; label: string }[]>([]);
      const [project, setProjectList] = useState<{ value: number; label: string }[]>([]);
      const [assetName, setAssetNameList] = useState<{ value: string; label: string }[]>([]); 
      const [reporters, setReportersNameList] = useState<{ value: string; label: string }[]>([]);
      const [categories, setCategoriesNameList] = useState<{ value: string; label: string }[]>([]);
      const statuses = ["Fault Reported", "Under Repairs", "Repair Completed", "Waiting for Parts"];
      useEffect(() => {
          if (familyAssetName.length === 0) getAssetTypeList(1, PAGESEND,);
        }, [familyAssetName]);

      useEffect(() => {
          if (project.length === 0) getProjectList(1, PAGESEND,);
        }, [project]);

      useEffect(() => {
          if (categories.length === 0) getCategoriesList(1, PAGESEND,);
        }, [categories]);

      useEffect(() => {
        if (reporters.length === 0) getReportersNameList(1, PAGESEND,);
      }, [reporters]);  
      

         const getAssetNameList = async (familyAssetId: number) => {
            console.log("Fetching asset names for familyAssetId:", familyAssetId); // Log the input
        
            dispatch(setLoading(true));
            try {
                const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
                console.log("API Response:", { data, status }); // Log the API response
        
                if (status.code === 200 && Array.isArray(data) && data.length > 0) {
                    console.log("Raw assetName data:", data); // Log raw data
        
                    const updatedData: { label: string; value: string }[] = data.map(
                        (assetName: string) => ({
                            value: assetName, // Use assetName directly
                            label: assetName, // Use assetName directly
                        })
                    );
                    updatedData.unshift({ label: "Select Assetname", value: "" }); // Add default option        
                    setAssetNameList(updatedData);
                } else {
                    console.log("No asset names found or status is not 200");
                }
            } catch (error: any) {
                console.error("Error fetching asset names:", error); // Log errors
                CustomMessage(error?.message, "error", enqueueSnackbar);
            } finally {
                dispatch(setLoading(false));
                console.log("Loading state set to false");
            }
        };
      
      const getReportersNameList = async (page: number, rows: number) => {
        dispatch(setLoading(true));
        console.log("Fetching asset types...");      
        try {
          const { data, status } = await getUsersMasterDataList(page, rows, {
            familyAssetId: { value: "", matchMode: "startsWith" }
          });      
          console.log("Asset type response:", data, status);      
          if (status.code === 200 && data?.length > 0) {
            const updatedData = data.map((val) => ({
              value: String(val.user_id), // Convert user_id to string
               label: val.name ?? "", // Ensure label is always a string
            }));      
            updatedData.unshift({ label: "Select User", value: "0" });
            setReportersNameList(updatedData);
            console.log("Updated asset type list:", updatedData);   
          }
        } catch (error: any) {
          console.error("Error fetching asset types:", error);
          CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
          dispatch(setLoading(false));
          console.log("Asset type fetch completed.");
        }
      };

      const getCategoriesList = async (page: number, rows: number) => {
        dispatch(setLoading(true));
        
        try {
          const { data, status } = await getCategoryAssetMasterDataList(page, rows, {
            familyAssetId: { value: "", matchMode: "startsWith" }
          });      
          console.log("Asset type response:", data, status);      
          if (status.code === 200 && data?.length > 0) {
            const updatedData = data.map((val) => ({
              value: String(val.categoryId), // Convert user_id to string
               label: val.categoryName ?? "", // Ensure label is always a string
            }));      
            updatedData.unshift({ label: "Select Category", value: "0" });
            setCategoriesNameList(updatedData);
            console.log("Updated asset type list:", updatedData);   
          }
        } catch (error: any) {
          console.error("Error fetching asset types:", error);
          CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
          dispatch(setLoading(false));
          console.log("Asset type fetch completed.");
        }
      };


  const handleReset = () => {
    setSearchText("");
    setFilters({
    currentLocationId: 0,
      worksite: "",
      // regionId: 0,
      user_id: 0,
      familyAssetId: 0,
      projectId: 0,
      assetName: "",
      categoryId: 0,
      faultStatus: "",
    });
    fetchFaults(1, 12, {
      currentLocationId: 0,
      // regionId: 0,
      worksite: "",
      user_id: 0,
      familyAssetId: 0,
      assetName: "",
    }, "");
    
  };
const getAssetTypeList = async (page: number, rows: number) => {
  dispatch(setLoading(true));
  console.log("Fetching asset types...");

  try {
    const { data, status } = await getFamilyAssetMasterDataList(page, rows, {
      familyAssetId: { value: "", matchMode: "startsWith" }
    });

    console.log("Asset type response:", data, status);

    if (status.code === 200 && Array.isArray(data) && data.length > 0) {
      const updatedData = data.map((val) => ({
        value: val.familyAssetId,
        label: val.familyName,
      }));

      // Always prepend "Select" option
      updatedData.unshift({ label: "Select Assettype", value: 0 });

      setAssetTypeList(updatedData);
      console.log("Updated asset type list:", updatedData);

      // If you're reusing the same list elsewhere
      setFamilyAssetName(updatedData);
    }
  } catch (error: any) {
    console.error("Error fetching asset types:", error);
    CustomMessage(error?.message, "error", enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
    console.log("Asset type fetch completed.");
  }
};

    const getProjectList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    console.log("Fetching asset types...");
  
    try {
      const { data, status } = await getProjectMasterDataList(page, rows, {
        familyAssetId: { value: "", matchMode: "startsWith" }
      });
  
      console.log("Asset type response:", data, status);
  
      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.projectId,
          label: val.projectName,
        }));
  
        updatedData.unshift({ label: "Select Project", value: 0 });
  
        setProjectList(updatedData);
        console.log("Updated pr0ject type list:", updatedData);

        setFamilyAssetName(updatedData); 
    
        
      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };
  const [paginationData, setPaginationData] = useState<{
      page: number;
      rows: number;
      totalRecords: number;
    }>({
      page: 1,
      rows: 100,
      totalRecords: 0,
    }); 

  const fetchFaults = async(page: number, rows: number, filters: Record<string, any> = {}, searchTerm: string = searchText) => {
    setLoading(true);
    try {
      const response = await getListOfFault(page, rows , filters, searchTerm); // Fetch page 1 with 10 rows
      const { data, status, pagination } = response;
      setFaults(response.data);
      setPaginationData({
        page: pagination.currentPage,
        rows: pagination.limit,
        totalRecords: pagination.totalCount,
      });
    } catch (error) {
      console.error("Error fetching faults:", error);
    }
    setLoading(false);
  };
  const handleSearch = () => {
    fetchFaults(1, 12, filters, searchText); // Call with search text
  }; 
  //const [filterData, setFilterData] = useState<Record<string, any>>({});
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);

    const exportCSV = (selectionOnly: boolean) => {
      if (!dt.current) {
        alert("No data available to export.");
        return;
      }
  
      // Get table data from PrimeReact's DataTable
      const data = dt.current.props.value || [];
  
      if (selectionOnly) {
        const selectedData = dt.current.props.selection || [];
        if (selectedData.length === 0) {
          alert("No rows selected for export.");
          return;
        }
        exportToExcel(selectedData);
      } else {
        exportToExcel(data);
      }
    };
  
    const exportToExcel = (data: any[]) => {
      if (!data || data.length === 0) {
        alert("No data to export.");
        return;
      }
      
    console.log("Export data row example:", data[0]);
      
  
    // Format data for Excel
   const rows = data.map((row) => ({
     "ID": row.faultId,
    "Name": row.name,
    "Country": row.countryName,
    "Region": row.regionName,
    "Project": row.projectName,
    "Family": row.familyName,
    "Asset Name": row.assetName,
    "Hour Meter": row.hourMeter,
    "Fault": row.fault,
    "Worksite": row.worksite,
    "Fixed User": Array.isArray(row.fixedUserNames) ? row.fixedUserNames.join(", ") : row.fixedUserNames || "",
    "Parts Used": row.partsUsed,
    "Work Carried Out": row.workCarriedOut,
    "Fault Status": row.faultStatus,
    "Hours Spent": row.hoursSpent,
    "Category Name": row.categoryName
    
  
  }));
  
  
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
  
    // Step 3: Apply hyperlinks
    const range = XLSX.utils.decode_range(worksheet["!ref"] || "");
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const currentRow = data[R - 1]; // Map to original data
  
      const columns = [
        { key: "Asset Image", id: currentRow.imageAttachmentId },
        { key: "Capex Attachment", id: currentRow.capexAttachmentId },
        { key: "Logistics Attachment", id: currentRow.logisticsAttachmentId },
      ];
  
      columns.forEach((col) => {
        const colIndex = Object.keys(rows[0]).indexOf(col.key);
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: colIndex });
  
        if (worksheet[cellAddress] && worksheet[cellAddress].v.startsWith("Download") && col.id) {
          worksheet[cellAddress].l = {
            Target: FILE_DOWNLOAD_PREVIEW + col.id,
            Tooltip: "Click to download",
          };
          worksheet[cellAddress].s = {
            font: { color: { rgb: "0000FF" }, underline: true },
          };
        }
      });
    }
  
    // Step 4: Format headers
    const headerRow = Object.keys(rows[0]);
    worksheet["!cols"] = headerRow.map(() => ({ wch: 25 }));
  
    headerRow.forEach((col, index) => {
      const cellAddress = XLSX.utils.encode_col(index) + "1";
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "0074D9" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });
  
    // Step 5: Finalize and download
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exported Data");
    XLSX.writeFile(workbook, "exported_data.xlsx");
  };

  const renderHeader = () => {
    return (
      <>
      <h2 style={{ margin: "0 0 12px 8px", fontWeight: 500, fontSize: "18px" }}>
        Search Faults
      </h2>
      <Grid container spacing={2}>  
        <Grid item container spacing={2} xs={12}>
          
          <Grid item xs={12} md={2}>
            <TextField
              fullWidth
              size="small"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search Fault"
              variant="outlined"

                sx={{
                backgroundColor: "transparent",   // 👈 removes white fill
              }}
            />
          </Grid>        
          <Grid item xs={12} md={2}>
            <Autocomplete
              options={countryName}
              getOptionLabel={(option) => option.label}
              value={countryName.find((c) => c.value === filters.currentLocationId) || null}
              onChange={(e, newValue) => {
                const value = newValue ? newValue.value : 0;
                setFilters({ ...filters, currentLocationId: value });
                fetchFaults(1, 12, { ...filters, currentLocationId: value }, searchText);
              }}
              renderInput={(params) => (
                <TextField {...params} label="" size="small" variant="outlined" />
              )}
            />

          </Grid>     
          <Grid item xs={12} md={2}>
            <Autocomplete
              
              options={project}
              getOptionLabel={(option) => option.label || ""}
              value={project.find((p) => p.value === filters.projectId) || null}
              onChange={(event, newValue) => {
                const value = newValue ? newValue.value : 0;
                setFilters({ ...filters, projectId: value });
                fetchFaults(1, 12, { ...filters, projectId: value }, searchText);
              }}
              renderInput={(params) => (
                 <TextField {...params} label="" size="small" variant="outlined" />
              )}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Autocomplete
            
              options={reporters}
              getOptionLabel={(option) => option.label || ""}  
              value={
                reporters.find(
                  (r) => String(r.value) === String(filters.user_id)
                ) || null
              }
              onChange={(event, newValue) => {
                const value = newValue ? Number(newValue.value) : 0;
                setFilters({ ...filters, user_id: value });
                fetchFaults(1, 12, { ...filters, user_id: value }, searchText);
              }}
              renderInput={(params) => (
                 <TextField {...params} label="" size="small" variant="outlined" />
              )}
            />
          </Grid>
            <Grid item xs={12} md={2}>
             <Autocomplete         
          options={assetType}
          getOptionLabel={(option) => option.label || ""}
          value={
            assetType.find(
              (a) => String(a.value) === String(filters.familyAssetId)
            ) || null
          }
          onChange={(event, newValue) => {
            const value = newValue ? Number(newValue.value) : 0;
            getAssetNameList(value);
            setFilters({ ...filters, familyAssetId: value });
            fetchFaults(1, 12, { ...filters, familyAssetId: value }, searchText);
          }}
          renderInput={(params) => (
             <TextField {...params} label="" size="small" variant="outlined" />
          )}
        />
          </Grid>
          <Grid item xs={12} md={2}>
          <Autocomplete         
          options={assetName}
          getOptionLabel={(option) => option.label || ""}
          value={
            assetName.find(
              (a) => String(a.value) === String(filters.assetName)
            ) || null
          }
          onChange={(event, newValue) => {
            const value = newValue ? newValue.value : "";
            setFilters({ ...filters, assetName: value });
            fetchFaults(1, 12, { ...filters, assetName: value }, searchText);
          }}
          renderInput={(params) => (
             <TextField {...params} label="" size="small" variant="outlined" />
          )}
        />
          </Grid>

        </Grid>
        <Grid item container spacing={2} xs={12}>

          <Grid item xs={12} md={2}>
            <Autocomplete         
              options={categories}
              getOptionLabel={(option) => option.label || ""}
              value={
                categories.find(
                  (c) => String(c.value) === String(filters.categoryId)
                ) || null
              }
              onChange={(event, newValue) => {
                const value = newValue ? Number(newValue.value) : 0;
                setFilters({ ...filters, categoryId: value });
                fetchFaults(1, 12, { ...filters, categoryId: value }, searchText);
              }}
              renderInput={(params) => (
                 <TextField {...params} label="" size="small" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={2}>
             <Autocomplete          
          options={statuses.map((s) => ({ label: s, value: s }))}
          getOptionLabel={(option) => option.label || ""}
          value={
            statuses
              .map((s) => ({ label: s, value: s }))
              .find((s) => s.value === filters.faultStatus) || null
          }
          onChange={(event, newValue) => {
            const value = newValue ? newValue.value : "";
            setFilters({ ...filters, faultStatus: value });
            fetchFaults(1, 12, { ...filters, faultStatus: value }, searchText);
          }}
          renderInput={(params) => (
             <TextField {...params} label="" size="small" variant="outlined" />
          )}
        />
          </Grid>
          <Grid item sx={{ width: "10%" }}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={handleReset}
            >
              Reset
            </Button>
          </Grid>

          {/* Export Button */}
          <Grid item sx={{ width: "10%" }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => exportCSV(true)}
            >
              Export
            </Button>
          </Grid>
        </Grid>
      </Grid>
      </>
    );
  };

  
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleSearch();
    }, 300); // Debounce delay (300ms)
  
    return () => clearTimeout(delayDebounceFn); // Cleanup function to avoid unnecessary API calls
  }, [searchText]); // Runs whenever searchText changes

  const handleSelectAssetTypeChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
      name: keyof assetFamilyMaster,
      name2: keyof assetFamilyMaster
    ) => {
      const updatedData: Partial<faultTypes> = { ...formData };     
      updatedData[name] = (e.target as { value: { label: string } }).value?.label || "";
      updatedData[name2] = (e.target as { value: { value: number } }).value?.value || 0;
      updatedData.assetName = "";    
      setFormData(updatedData as faultTypes);
      getAssetNameList((e.target as { value: { value: number } }).value?.value || 0)
    };

    
  


  const header = renderHeader();
  return (
    <div className="p-0">
        {!open ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2, // ✅ Add padding for better spacing
          }}
        >
          <ReusableDataTable
            ref={dt}
            data={faults} // ✅ Ensure faults is an array
            columns={columns} // ✅ Pass the columns definition
            onFetchData={fetchFaults} // ✅ Function to fetch data
            emptyMessage="No data found."
            globalFilterFields={[]} // ✅ Empty array is now valid
            header={header}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode="multiple"
            //rowsPerPageOptions={[12, 12, 50, 70, 100]}
            filters={filters}
           // setFilters={setFilterData}
            pagination={paginationData}
            setPagination={setPaginationData}
            onRowDoubleClick={(rowData) => {
                          console.log('Double-click row:', rowData);
                       handleEditFault(rowData.faultId);
                        }}
          />
        </Box>
      ) : (
        <EditFault
        setOpen={setOpen}
        setPathname={setPathname}
        faultId={faultId}
        setFaultId={setFaultId}
        selectedValue={selectedValue?.toString() ?? ""}
        faultData={{ ...faultData, date: faultData.date ?? "" }}
        setFaultData={setFaultData}
        getListOfSelectedProducts={() =>
          fetchFaults(paginationData.page, paginationData.rows, filters)
        }
        />
      )}    
      </div>
  );

}
  

export default SearchFault;

